export default {
  PRIVACY_POLICY: 'privacy',
  TERMS_OF_USE: 'tou',
};
